import { merge } from "lodash";

const initialState = {
  /* Campos etapa 1 */
  titulo: "",
  obraMaterialList: [
    { text: "SIM", value: true },
    { text: "NÃO", value: false },
  ],
  possuiObra: false,
  possuiMaterial: false,
  depreciaMes: false,
  vlrAlmoxarifado: 0.0,
  aisDataBase: null,
  origemDadosAis: "AIS",
  dataSimulacaoLaudo: null,
  dataImobilizacaoInicio: null,
  dataImobilizacaoFim: null,
  /* Campos etapa 2 */
  origemDadosBancoPrecosList: [
    { text: "CÁLCULO", value: "CALCULO" },
    { text: "CSV", value: "CSV" },
  ],
  origemDadosBancoPrecos: "CALCULO",
  bancoPrecos: {
    id: null,
    nome: "",
  },
  bancoPrecosMateriais: false,
  bancoPrecosTucagens: false,
  infoUploadedFileMaterial: {
    id: null,
    delimitador: null,
    involucro: null,
    escape: null,
    mapeamento: {
      CODIGO_MATERIAL: "",
      VALOR_UNITARIO: "",
    },
    camposObrigatorios: ["CODIGO_MATERIAL", "VALOR_UNITARIO"],
    needToUploadFakeFile: false,
  },
  infoUploadedFileTucagem: {
    id: null,
    delimitador: null,
    involucro: null,
    escape: null,
    mapeamento: {
      TUC: "",
      A1: "",
      A2: "",
      A3: "",
      A4: "",
      A5: "",
      A6: "",
      VALOR_UNITARIO: "",
    },
    camposObrigatorios: [
      "TUC",
      "A1",
      "A2",
      "A3",
      "A4",
      "A5",
      "A6",
      "VALOR_UNITARIO",
    ],
    needToUploadFakeFile: false,
  },
  /* Campos etapa 3 */
  saneamentoVoc: {
    calculos: {
      0: {
        nome_calculo: null,
        saneamento_voc_id: null,
        tipologia_aneel: "RAU",
      },
      1: {
        nome_calculo: null,
        saneamento_voc_id: null,
        tipologia_aneel: "RAR",
      },
      2: {
        nome_calculo: null,
        saneamento_voc_id: null,
        tipologia_aneel: "RDS",
      },
      3: {
        nome_calculo: null,
        saneamento_voc_id: null,
        tipologia_aneel: "SDU",
      },
      4: {
        nome_calculo: null,
        saneamento_voc_id: null,
        tipologia_aneel: "SDR",
      },
      5: {
        nome_calculo: null,
        saneamento_voc_id: null,
        tipologia_aneel: "SMU",
      },
      6: {
        nome_calculo: null,
        saneamento_voc_id: null,
        tipologia_aneel: "SMR",
      },
      7: {
        nome_calculo: null,
        saneamento_voc_id: null,
        tipologia_aneel: "LAR",
      },
      8: {
        nome_calculo: null,
        saneamento_voc_id: null,
        tipologia_aneel: "LAU",
      },
      9: {
        nome_calculo: null,
        saneamento_voc_id: null,
        tipologia_aneel: "LARS",
      },
    },
  },
  percentuais: {
    /* tipoTipologia = ('Informar percentual' || 'Saneamento do VOC') */
    RAU: { perc_fator_saneamento: "100", tipoTipologia: "Informar percentual" },
    RAR: { perc_fator_saneamento: "100", tipoTipologia: "Informar percentual" },
    RDS: { perc_fator_saneamento: "100", tipoTipologia: "Informar percentual" },
    SDU: { perc_fator_saneamento: "100", tipoTipologia: "Informar percentual" },
    SDR: { perc_fator_saneamento: "100", tipoTipologia: "Informar percentual" },
    SMU: { perc_fator_saneamento: "100", tipoTipologia: "Informar percentual" },
    SMR: { perc_fator_saneamento: "100", tipoTipologia: "Informar percentual" },
    LAR: { perc_fator_saneamento: "100", tipoTipologia: "Informar percentual" },
    LAU: { perc_fator_saneamento: "100", tipoTipologia: "Informar percentual" },
    LARS: {
      perc_fator_saneamento: "100",
      tipoTipologia: "Informar percentual",
    },
  },
};

const state = initialState;

const getters = {};

const actions = {
  setSimulacaoLaudoIncremental({ commit }, value) {
    commit("SET_SIMULACAO_LAUDO_INCREMENTAL", value);
  },
  clearSimulacaoLaudoIncremental({ commit }, value) {
    commit("CLEAR_SIMULACAO_LAUDO_INCREMENTAL", initialState);
  },
};

const mutations = {
  SET_SIMULACAO_LAUDO_INCREMENTAL: (state, value) =>
    (state = merge(state, value)),
  CLEAR_SIMULACAO_LAUDO_INCREMENTAL: (state, value) => {
    state = merge(state, value);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
